"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asynciterator_1 = require("asynciterator");

var LRUCache = require("lru-cache");
/**
 * An abstract quad iterator that can iterate over consecutive RDF sources.
 *
 * This iterator stores a queue of sources that need to be iterated over.
 * For each source, its collected metadata is maintained.
 */


var LinkedRdfSourcesAsyncRdfIterator =
/*#__PURE__*/
function (_asynciterator_1$Buff) {
  _inherits(LinkedRdfSourcesAsyncRdfIterator, _asynciterator_1$Buff);

  function LinkedRdfSourcesAsyncRdfIterator(cacheSize, subject, predicate, object, graph, firstUrl, options) {
    var _this;

    _classCallCheck(this, LinkedRdfSourcesAsyncRdfIterator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LinkedRdfSourcesAsyncRdfIterator).call(this, options));
    _this.cacheSize = cacheSize;
    _this.subject = subject;
    _this.predicate = predicate;
    _this.object = object;
    _this.graph = graph;
    _this.sourceStates = [];
    _this.firstUrl = firstUrl;
    _this.started = false;
    _this.iterating = false;
    return _this;
  }
  /**
   * This method can optionally called after constructing an instance
   * for allowing the sources state to be cached.
   *
   * When calling without args, then the default logic will be followed to determine the sources state.
   * When calling with an arg, then the given sources state will be set instead of following the default logic.
   *
   * After calling this method, the `sourcesState` field can be retrieved and optionally cached.
   *
   * This sources state also contains a hash of all handled datasets that will be copied upon first use.
   *
   * @param {ISourcesState} sourcesState An optional sources state.
   */


  _createClass(LinkedRdfSourcesAsyncRdfIterator, [{
    key: "setSourcesState",
    value: function setSourcesState(sourcesState) {
      if (sourcesState) {
        this.sourcesState = sourcesState;
      } else {
        this.sourcesState = {
          sources: new LRUCache({
            max: this.cacheSize
          })
        };
        this.getNextSourceCached(this.firstUrl, {}); // Ignore the response, we just want the promise to be cached
      }
    }
  }, {
    key: "_read",
    value: function _read(count, done) {
      var _this2 = this;

      if (!this.started) {
        this.started = true;

        if (!this.sourcesState) {
          this.setSourcesState();
        }

        this.sourcesState.sources.get(this.firstUrl).then(function (sourceState) {
          _this2.startIterator(sourceState, true);

          done();
        }).catch(function (e) {
          return _this2.emit('error', e);
        });
      } else if (!this.iterating && this.nextSource) {
        var nextSource = this.nextSource;
        this.nextSource = null;
        this.getNextUrls(nextSource.metadata).then(function (nextUrls) {
          return Promise.all(nextUrls.map(function (nextUrl) {
            return _this2.getNextSourceCached(nextUrl, nextSource.handledDatasets);
          }));
        }).then(function (newSources) {
          if (newSources.length === 0 && _this2.sourceStates.length === 0) {
            _this2.close();
          } else {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = newSources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var sourceState = _step.value;

                _this2.sourceStates.push(sourceState);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            _this2.startIterator(_this2.sourceStates[0], false);

            _this2.sourceStates.splice(0, 1);
          }

          done();
        }).catch(function (e) {
          return _this2.emit('error', e);
        });
      } else {
        done();
      }
    }
  }, {
    key: "getNextSourceCached",
    value: function getNextSourceCached(url, handledDatasets) {
      var source = this.sourcesState.sources.get(url);

      if (source) {
        return source;
      }

      source = this.getNextSource(url, handledDatasets);
      this.sourcesState.sources.set(url, source);
      return source;
    }
    /**
     * Start a new iterator for the given source.
     * Once the iterator is done, it will either determine a new source, or it will close the iterator.
     * @param {ISourceState} startSource The start source state.
     * @param {boolean} emitMetadata If the metadata event should be emitted.
     */

  }, {
    key: "startIterator",
    value: function startIterator(startSource, emitMetadata) {
      var _this3 = this;

      // Asynchronously execute the quad pattern query
      this.iterating = true;
      var it = startSource.source.match(this.subject, this.predicate, this.object, this.graph);
      var currentMetadata = startSource.metadata;
      var ended = false; // If the response emits metadata, override our metadata
      // For example, this will always be called for QPF sources (if not, then something is going wrong)

      it.on('metadata', function (metadata) {
        if (ended) {
          _this3.destroy(new Error('Received metadata AFTER the source iterator was ended.'));
        }

        currentMetadata = metadata;
      });
      it.on('data', function (quad) {
        _this3._push(quad);

        _this3.readable = true;
      });
      it.on('error', function (e) {
        return _this3.destroy(e);
      });
      it.on('end', function () {
        ended = true;

        if (emitMetadata) {
          // Emit the metadata after all data has been processed.
          _this3.emit('metadata', currentMetadata);
        } // Store the metadata for next ._read call


        _this3.nextSource = {
          handledDatasets: Object.assign({}, startSource.handledDatasets),
          metadata: currentMetadata,
          source: null
        };
        _this3.iterating = false;
        _this3.readable = true;
      });
    }
  }]);

  return LinkedRdfSourcesAsyncRdfIterator;
}(asynciterator_1.BufferedIterator);

exports.LinkedRdfSourcesAsyncRdfIterator = LinkedRdfSourcesAsyncRdfIterator;